import { combineReducers } from "@reduxjs/toolkit"

import {
    callReducer,
    chatReducer,
    clientCallNotificationReducer,
    userReducer,
    bookingReducer,
    psyCatalogMetaReducer,
    surveyReducer,
    psyCatalogReducer,
} from "./slices"

export const rootReducer = combineReducers({
    call: callReducer,
    chat: chatReducer,
    clientCallNotification: clientCallNotificationReducer,
    user: userReducer,
    booking: bookingReducer,
    psyCatalogMeta: psyCatalogMetaReducer,
    survey: surveyReducer,
    psyCatalog: psyCatalogReducer,
})
